import React from 'react';
import {observer} from "mobx-react";
import {GameInfo} from '../../../../services/games/game-info';
import {StaticVideoSlidePlayerComponent} from './components/static-video-slide-player/static-video-slide-player.component';
import {StaticVideoSlideFooterComponent} from './components/static-video-slide-footer/static-video-slide-footer.component';
import {VideoSlideLayoutComponent} from '../../../video-slide-layout/video-slide-layout/video-slide-layout.component';
import {VideoSlideContentLayoutComponent} from '../../../video-slide-layout/video-slide-content-layout/video-slide-content-layout.component';
import {VideoSlideFooterLayoutComponent} from '../../../video-slide-layout/video-slide-footer-layout/video-slide-footer-layout.component';

interface StaticVideoSlideComponentProps {
    gameInfo: GameInfo;
    isStaticVideoFromCdnPOC?: boolean;
}
export const StaticVideoSlideComponent: React.FC<StaticVideoSlideComponentProps> = observer((props) => {
    return (
        <VideoSlideLayoutComponent>
            <VideoSlideContentLayoutComponent>
                <StaticVideoSlidePlayerComponent gameInfo={props.gameInfo} isStaticVideoFromCdnPOC={props.isStaticVideoFromCdnPOC} />
            </VideoSlideContentLayoutComponent>
            <VideoSlideFooterLayoutComponent
                gameInfo={props.gameInfo}
                secondaryText={<StaticVideoSlideFooterComponent gameInfo={props.gameInfo} type={"bets"} />}
            />
        </VideoSlideLayoutComponent>
    )
})
